import * as yup from 'yup';
import {
  addOptionalNullableToSchema,
  optionalNameSchema,
  optionalNullableNameSchema,
  stateSchema,
} from '@common/schema';

const requiredErrorMessage = 'Field is required';

export const createManageTeamSchema = yup.object().shape({
  name: yup.string().required(requiredErrorMessage),
  description: optionalNameSchema,
  record_type: yup.string().required(requiredErrorMessage),
  record_id: yup.string().required(requiredErrorMessage),
  records: yup.array().of(
    yup.object({
      record_type: yup.string().required(requiredErrorMessage),
      record_id: yup.string().required(requiredErrorMessage),
    }),
  ),
  city: optionalNullableNameSchema,
  state: addOptionalNullableToSchema(stateSchema),
});
